import _ from 'lodash';
import { InfoSectionLayoutId, TabsDirection, } from '../constants';
import { getStyleParamsWithDefaults } from '@wix/wixstores-client-common-components/dist/src/outOfIframes/defaultStyleParams/getStyleParamsWithDefaults';
var fontStyleParam = false;
var isMobile = function (formFactor) { return formFactor === "Mobile" /* Mobile */; };
export var DEFAULT_STYLE_PARAMS = {
    booleans: {
        productPage_galleryZoom: true,
        productPage_navigation: true,
        productPage_productAction: true,
        productPage_productInfoSection: true,
        productPage_productPrice: true,
        productPage_productQuantity: true,
        productPage_productSku: true,
        productPage_socialNetworkfacebook: true,
        productPage_socialNetworkfancy: true,
        productPage_socialNetworkgoogle: true,
        productPage_socialNetworkpinterest: true,
        productPage_socialNetworktwitter: true,
        productPage_infoSectionShowDeviders: true,
        productPage_socialNetworks: true,
        productPage_openMinicart: true,
        full_width: false,
    },
    numbers: {
        productPage_descriptionVisibleLineNumbers: 0,
        productPage_galleryImageRatio: -1,
        productPage_galleryImageMode: 1 /* CROP */,
        productPage_layoutId: 1 /* Classic */,
        productPage_infoSectionTypeId: InfoSectionLayoutId.Collapse,
        productPage_infoSectionColumnNumber: 1,
    },
    fonts: {
        productPage_galleryNavigationType: { value: "thumbnails" /* THUMBNAILS */, fontStyleParam: fontStyleParam },
        productPage_galleryNavigationPosition: { value: "bottom" /* BOTTOM */, fontStyleParam: fontStyleParam },
        productPage_galleryNavigationLocation: { value: "outside" /* OUTSIDE */, fontStyleParam: fontStyleParam },
        productPage_productDetailsAlignment: { value: "left" /* LEFT */, fontStyleParam: fontStyleParam },
        productPage_infoSectionAlignment: { value: TabsDirection.start, fontStyleParam: fontStyleParam },
    },
};
export function getLayoutIdFromProps(props) {
    var formFactor = props.formFactor, layoutId = props.globals.style.styleParams.numbers.productPage_layoutId;
    if (isMobile(formFactor)) {
        return 3 /* Mobile */;
    }
    return layoutId;
}
export function getStyleParamsFromProps(props) {
    var _a = props.globals.style.styleParams, _b = _a.fonts, navigationPositionString = _b.productPage_galleryNavigationPosition.value, navigationTypeString = _b.productPage_galleryNavigationType.value, navigationLocationString = _b.productPage_galleryNavigationLocation.value, _c = _a.numbers, imageMode = _c.productPage_galleryImageMode, imageRatioId = _c.productPage_galleryImageRatio, infoSectionTypeId = _c.productPage_infoSectionTypeId, infoSectionColumnNumber = _c.productPage_infoSectionColumnNumber, _d = _a.booleans, shouldShowZoom = _d.productPage_galleryZoom, shouldShowDivider = _d.productPage_infoSectionShowDeviders, shouldShowPrice = _d.productPage_productPrice, shouldShowSku = _d.productPage_productSku, shouldShowQuantity = _d.productPage_productQuantity, shouldShowNavigation = _d.productPage_navigation, shouldShowInfoSection = _d.productPage_productInfoSection, shouldShowSocialNetwork = _d.productPage_socialNetworks, shouldShowAddToCartButton = _d.productPage_productAction, isFullWidth = _d.full_width;
    var navigationPosition = navigationPositionString;
    var navigationType = navigationTypeString;
    var navigationLocation = navigationLocationString;
    return {
        navigationPosition: navigationPosition,
        navigationType: navigationType,
        navigationLocation: navigationLocation,
        imageMode: imageMode,
        imageRatioId: imageRatioId,
        infoSectionTypeId: infoSectionTypeId,
        infoSectionColumnNumber: infoSectionColumnNumber,
        shouldShowDivider: shouldShowDivider,
        shouldShowZoom: shouldShowZoom,
        shouldShowPrice: shouldShowPrice,
        shouldShowSku: shouldShowSku,
        shouldShowQuantity: shouldShowQuantity,
        shouldShowNavigation: shouldShowNavigation,
        shouldShowInfoSection: shouldShowInfoSection,
        shouldShowSocialNetwork: shouldShowSocialNetwork,
        shouldShowAddToCartButton: shouldShowAddToCartButton,
        isFullWidth: isFullWidth,
    };
}
export function getRuntimeStyleParams(styleParams, _a) {
    var formFactor = _a.formFactor;
    var result = getStyleParamsWithDefaults(styleParams, function () { return ({ defaults: DEFAULT_STYLE_PARAMS }); });
    var mobile = {};
    if (isMobile(formFactor)) {
        mobile = {
            booleans: {
                productPage_galleryZoom: false,
            },
            numbers: {
                productPage_galleryImageRatio: 2,
            },
            fonts: {
                productPage_galleryNavigationType: { value: "dots" /* DOTS */, fontStyleParam: fontStyleParam },
                productPage_galleryNavigationPosition: { value: "bottom" /* BOTTOM */, fontStyleParam: fontStyleParam },
                productPage_galleryNavigationLocation: { value: "outside" /* OUTSIDE */, fontStyleParam: fontStyleParam },
            },
        };
    }
    return _.merge({}, result, mobile);
}
//# sourceMappingURL=styleParamsService.js.map